import { call, put, takeLatest } from "redux-saga/effects";
import { axiosRestInstance } from "../../../common/axios";
import { AxiosResponse } from "axios";
import { PartnerLogsType } from "../../slices/partner-logs/Types";
import { partnerLogsSliceAction } from "../../slices/partner-logs/index";
import {
  partnerLogsSagaActionTypes,
} from "./saga-actions";

type getPartnerLogsAPIResponseType = {
  success: boolean;
  message: string;
  data: PartnerLogsType[];
};

const getPartnerLogsAPI = async (partnerId: number) => {
  const response = await axiosRestInstance
    .get<AxiosResponse<getPartnerLogsAPIResponseType>>(`/logs/logsData/${partnerId}`)
    .then((res) => res.data);
  return response;
};

function* getPartnerLogsSaga(action: { 
  type: string; 
  partnerId: number; 
}) {
  try {
    yield put(partnerLogsSliceAction.setPartnerLogsLoading(true));
    const response: getPartnerLogsAPIResponseType = yield call(
      getPartnerLogsAPI,
      action.partnerId,
    );
    yield put(partnerLogsSliceAction.setPartnerLogs(response.data || []));
  } catch (e) {
    yield put(partnerLogsSliceAction.setPartnerLogs([]));
    console.log(e);
  } finally {
    yield put(partnerLogsSliceAction.setPartnerLogsLoading(false));
  }
}

function* partnerLogsSaga() {
  yield takeLatest(
    partnerLogsSagaActionTypes.callGetPartnerLogsSaga,
    getPartnerLogsSaga
  );
}

export default partnerLogsSaga;
